const bypassHeaderName = import.meta.env.VITE_GQL_BYPASS_HEADER_NAME
const bypassHeaderValue = import.meta.env.VITE_GQL_BYPASS_HEADER_VALUE

export function resolveBypassHeader() {
  if (bypassHeaderName) {
    return { [bypassHeaderName]: bypassHeaderValue }
  }

  return {}
}
